import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import openInstantBookingModal from '@spotahome/ui-library/src/tenant/components/InstantBookingModal';

const InstantBookingLabelDescription = ({ rules = [] }) => {
  const handleOnClick = e => {
    e.preventDefault();
    openInstantBookingModal({ rules });
  };

  return (
    <div
      role="button"
      tabIndex={-1}
      onClick={handleOnClick}
      dangerouslySetInnerHTML={{
        __html: trans('listing.labels.instantBooking.description')
      }}
    />
  );
};

InstantBookingLabelDescription.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, params: PropTypes.shape({}) }))
};

export default InstantBookingLabelDescription;
